module.exports = __webpack_public_path__ + "static/img/hos-hk-india-img-hk-tablet-01@w.a0e62a1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/hos-hk/hos-hk-india-img-hk-tablet-01@w.png
// module id = heCb
// module chunks = 0